import * as go from 'gojs';
import { registerGroupTemplate } from '../../common/utils/registerNodeTemplate';
import { groupNodeTemplate } from '../group-node';
import { groupOverrideResizingTool } from '../utils/group-resizing-tool';
import { groupOverrideDraggingTool } from './../utils/group-dragging-tool';
import { groupOverrideRotatingTool } from './../utils/group-rotating-tool';

export const setupGroupNode = (diagram: go.Diagram, categoryName: string) => {
  registerGroupTemplate(diagram, categoryName, groupNodeTemplate());
  groupOverrideResizingTool(diagram, categoryName);
  groupOverrideRotatingTool(diagram, categoryName);
  groupOverrideDraggingTool(diagram, categoryName);
  return registerDiagramListeners(diagram, categoryName);
};

const registerDiagramListeners = (diagram: go.Diagram, categoryName: string) => {
  const onChangingSelection = handleChangingSelection();
  const onChangedSelection = handleChangedSelection(categoryName);
  const onObjectSingleClicked = handleObjectSingleClicked(categoryName);

  diagram.addDiagramListener('ChangingSelection', onChangingSelection);
  diagram.addDiagramListener('ChangedSelection', onChangedSelection);
  diagram.addDiagramListener('ObjectSingleClicked', onObjectSingleClicked);

  return () => {
    diagram.removeDiagramListener('ChangingSelection', onChangingSelection);
    diagram.removeDiagramListener('ChangedSelection', onChangedSelection);
    diagram.removeDiagramListener('ObjectSingleClicked', onObjectSingleClicked);
  };
};

let previouslySelected: go.Set<go.Key> | null;
let candidateForSelection: go.Set<go.Key> | null;
let preventSelectionAction = false;

const handleChangingSelection =
  () =>
  ({ subject }: go.DiagramEvent) => {
    const parts = subject as go.Set<go.Part>;
    previouslySelected = parts.map((part) => part.key);
  };

const handleChangedSelection =
  (categoryName: string) =>
  ({ subject }: go.DiagramEvent) => {
    const iterator = (subject as go.Set<go.Part>)?.iterator;
    if (!iterator) {
      return;
    }
    if (preventSelectionAction) {
      preventSelectionAction = false;
      return;
    }

    candidateForSelection = new go.Set<go.Key>();
    while (iterator.next()) {
      const part = iterator.value;
      if (part.containingGroup?.category !== categoryName) {
        continue;
      }

      if (!part.containingGroup.isSelected) {
        part.containingGroup.isSelected = true;
        part.isSelected = false;

        if (previouslySelected?.has(part.containingGroup.key)) {
          candidateForSelection.add(part.key);
        }
      }
    }

    previouslySelected = null;
  };

const handleObjectSingleClicked =
  (categoryName: string) =>
  ({ diagram, subject }: go.DiagramEvent) => {
    const clickedElement = (subject as go.GraphObject)?.part;

    if (clickedElement?.category === categoryName && clickedElement?.isSelected) {
      diagram.select(clickedElement);
    }

    if (candidateForSelection?.has(clickedElement?.key) && !!clickedElement) {
      preventSelectionAction = true;
      diagram.selectCollection([...diagram.selection.toArray(), clickedElement]);
    }

    candidateForSelection = null;
  };
